const translationsCache = /* @__PURE__ */ new Map([]);
var cache_default = () => translationsCache;
export {
  cache_default as default
};
